import { MenuTab } from '@/resources/MenuTab';
import { AppCollection } from '@/stores/AppStore';

export const FETCH_MENU_TABS_KEY = 'fetch-menu-tabs';

export async function fetchMenuTabs(store: AppCollection, eventId: string, customFilter?: any) {
  const response = await store.fetchAll<MenuTab>(MenuTab.type, {
    filter: {
      scope: 'with_menu_groups',
      event_id: eventId,
      ...customFilter,
    },
  });

  return response.data as Array<MenuTab>;
}
